<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // COMPONENTS
    import OnboardingPreferences from './pages/onboarding-preferences/OnboardingPreferences.svelte';
    import OnboardingOrganization from './pages/onboarding-organization/OnboardingOrganization.svelte';
    import OnboardingSuccess from './pages/onboarding-success/OnboardingSuccess.svelte';

    // PLUGINS
    import { Router, Route } from 'svelte-navigator';

    // LAYOUT
    import LayoutAuthentication from 'src/app/library/layouts/layout-authentication/LayoutAuthentication.svelte';

    import RouteGuard from './RouteGuard.svelte';

</script>

<RouteGuard>

    <LayoutAuthentication>

        <Router primary = { false }>

            <Route path = 'preferences'>
                <OnboardingPreferences />
            </Route>

            <Route path = 'organization'>
                <OnboardingOrganization />
            </Route>

            <Route path = 'success'>
                <OnboardingSuccess />
            </Route>

        </Router>

    </LayoutAuthentication>

</RouteGuard>